import store from '@/store'
export default {
  install (Vue, options) {
    if (options.developmentOff && process.env.NODE_ENV === 'development') return
    Vue.config.errorHandler = (error, vm, mes) => {
      let info = {
        type: 'script',
        code: 0,
        mes: error.message,
        url: window.location.href
      }
      Vue.nextTick(() => {
        try {
          store.dispatch('addErrorLog', info)
        } catch (e) {
          // 防止 addErrorLog 内部抛错被 Vue 再次捕获交回 errorHandler，形成无限微任务死循环（prod 下会导致 CPU 100%）
          console.error('addErrorLog failed', e)
        }
      })
    }
  }
}
